import type { IAnalytics } from './analytics/types';
import type { IErrors } from './errors/types';
import type { ILogger } from './logging/types';
import type { IMetrics } from './metrics/types';
import type { ITracing } from './tracing/types';
import type { IObservabilityContext } from './types';
import { getActiveObservability } from './runtime';

/** API imperativa — requer ObservabilityProvider (ou setActiveObservability) ativo. */
export const metrics: IMetrics = {
  increment: (name, value) => getActiveObservability().metrics.increment(name, value),
  gauge: (name, value) => getActiveObservability().metrics.gauge(name, value),
  measure: (name, fn) => getActiveObservability().metrics.measure(name, fn),
  recordWebVital: (metric) => getActiveObservability().metrics.recordWebVital(metric),
};

export const logger: ILogger = {
  debug: (message, fields) => getActiveObservability().logger.debug(message, fields),
  info: (message, fields) => getActiveObservability().logger.info(message, fields),
  warn: (message, fields) => getActiveObservability().logger.warn(message, fields),
  error: (message, fields) => getActiveObservability().logger.error(message, fields),
};

export const errors: IErrors = {
  capture: (error, context) => getActiveObservability().errors.capture(error, context),
};

export const tracing: ITracing = {
  startSpan: (name, options) => getActiveObservability().tracing.startSpan(name, options),
};

export const analytics: IAnalytics = {
  track: (event, properties) => getActiveObservability().analytics.track(event, properties),
};

/** Contexto comum (sem PII) — AuthContext/Navbar pode chamar após /auth/me. */
export function setContext(partial: Partial<IObservabilityContext>): void {
  getActiveObservability().setContext(partial);
}

export function getContext(): IObservabilityContext {
  return getActiveObservability().getContext();
}
